<script setup>
import * as iotapi from "../iotapi.js";
import { ref, onMounted } from "vue";
import SensorGases from "./SensorGases.vue";
import SensorCo2 from "./SensorCo2.vue";
import SensorParticulas from "./SensorParticulas.vue";
import SensorSonido from "./SensorSonido.vue";
import SensorMeteo from "./SensorMeteo.vue";

const sensors = ref({});
const dataFetched = ref(false);

onMounted(async () => {
  await fetchData();
  const events = new EventSource(iotapi.API_BASE + "/events/tiempo_real");
  events.onerror = (error) => {
    console.error("Error recibiendo eventos: ", error);
  };
  events.onmessage = (stream) => {
    const sensor = JSON.parse(stream.data);
    console.debug("SSE: recibido sensor ", sensor);
    if (sensor.entityid) {
      const key = iotapi.filtraEntityId(sensor.entityid);
      if (sensors.value[key]) {
        sensors.value[key] = sensor;
      }
    }
  };
});

const t = (key) => {
  return iotapi.i18next.t(key);
};

const fetchData = async () => {
  try {
    const url = iotapi.API_BASE + "/tiempo_real";
    const res = await (await fetch(url)).json();
    for (const sensor in res) {
      const key = iotapi.filtraEntityId(sensor);
      sensors.value[key] = res[sensor];
    }
    dataFetched.value = true;
  } catch (e) {
    console.error(e);
  }
};
</script>

<template>
  <div>
    <div class="header section powered-design" id="home">
      <div class="shapes-container">
        <div class="shape shape-circle shape-circle-1">
          <div data-aos="fade-up-left" data-aos-duration="1500"></div>
        </div>
        <div class="shape shape-circle shape-circle-2">
          <div data-aos="fade-up-left" data-aos-duration="1200" data-aos-delay="500"></div>
        </div>
        <div class="shape shape-ring animation--rotating-diagonal">
          <div></div>
        </div>
        <div class="shape shape-triangle shape-animated">
          <div class="animation--rotating"></div>
        </div>

        <div class="shape pattern-dots-1"></div>
      </div>

      <div class="container bring-to-front">
        <div class="row">
          <div class="col-md-12 menu-header text-center" id="temps-real">
            <i class="fa fa-tachometer-alt fa-5x accent mb-3"></i>
            <h1 class="heading-line bold">
              {{ t("smart.tiemporeal.tiemporeal") }}
            </h1>
          </div>
        </div>

        <div class="container">
          <div class="row-menu" style="margin-top: -85px">
            <ul class="row list_style_none m-0 p-0">
              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.tiemporeal.qualitataire_gasos')" class="scrollto" href="./indicadors.html#gases">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-wind fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.tiemporeal.qualitataire_gasos") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a
                    :title="t('smart.tiemporeal.qualitataire_particules')"
                    class="scrollto"
                    href="./indicadors.html#particulas"
                  >
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-wind fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.tiemporeal.qualitataire_particules") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.tiemporeal.nivellso')" class="scrollto" href="./indicadors.html#sonido">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-microphone fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.tiemporeal.nivellso") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
              <li class="col-xs-6 col-sm-4 col-md-3 col-lg-2">
                <div class="rotated-cards">
                  <a :title="t('smart.tiemporeal.meteo')" class="scrollto" href="./indicadors.html#meteo">
                    <div data-aos="fade-down" data-aos-delay="100">
                      <div class="border-0 mb-4" style="border-radius: 20px">
                        <div class="card-body-indicador py-4 px-4">
                          <div
                            class="icon-box text-contrast icon-lg mb-4"
                            style="margin: auto; transform: translateY(25%)"
                          >
                            <i class="icon:nth-of-type(20) m-0 fa fa-thermometer-half fa-3x"></i>
                          </div>
                          <p class="sim_h6 bold mb-3 text-md-center" style="text-align: center">
                            {{ t("smart.tiemporeal.meteo") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <section class="section alter3-features" id="gases">
      <div class="container">
        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <div class="section-heading text-center">
              <i class="fas fa-wind fa-2x accent mb-3"></i>
              <h2 class="heading-line">
                {{ t("smart.tiemporeal.qualitataire_gasos") }}
              </h2>
            </div>
          </div>
        </div>

        <div class="row gap-y">
          <div class="col-md-12">
            <dl class="row">
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.qualitat") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.qualitat_texto") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.nivel") }}
              </dt>
              <dd class="col-12 col-sm-10">
                <img src="../img/iconos/calidad3-1.png" :alt="t('smart.tiemporeal.bueno')" />
                {{ t("smart.tiemporeal.bueno") }} &nbsp;&nbsp;
                <img src="../img/iconos/calidad3-2.png" :alt="t('smart.tiemporeal.moderado')" />
                {{ t("smart.tiemporeal.moderado") }} &nbsp;&nbsp;
                <img src="../img/iconos/calidad3-3.png" :alt="t('smart.tiemporeal.malo')" />
                {{ t("smart.tiemporeal.malo") }}
              </dd>
            </dl>
          </div>
        </div>

        <ul class="row list_style_none m-0 p-0">
          <sensor-gases v-if="dataFetched" :sensor="sensors.ENT_AQO_002"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.ENT_AQO_003"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.ENT_AQO_006"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.ENT_AQO_005"></sensor-gases>
          <sensor-gases
            v-if="dataFetched"
            :sensor="sensors.ENT_AQO_001"
            :mantenimiento="['no2', 'o3', 'so2', 'co']"
          ></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_01"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_02"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_03"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_04"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_05"></sensor-gases>
          <sensor-gases v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_06"></sensor-gases>
          <sensor-co2 v-if="dataFetched" :sensor="sensors.CF1_Sonda1_CO2"></sensor-co2>
        </ul>

        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <dl class="row">
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.no2") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.no2_des") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.o3") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.o3_des") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.so2") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.so2_des") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.co") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.co_des") }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="particulas">
      <div class="container">
        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <div class="section-heading text-center">
              <i class="fas fa-wind fa-2x accent mb-3"></i>
              <h2 class="heading-line">
                {{ t("smart.tiemporeal.qualitataire_particules") }}
              </h2>
            </div>
          </div>
        </div>

        <div class="row gap-y">
          <div class="col-md-12">
            <dl class="row">
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.qualitat") }}
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.qualitat_texto") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.nivel") }}
              </dt>
              <dd class="col-12 col-sm-10">
                <img src="../img/iconos/calidad3-1.png" :alt="t('smart.tiemporeal.bueno')" />
                {{ t("smart.tiemporeal.bueno") }} &nbsp;&nbsp;
                <img src="../img/iconos/calidad3-2.png" :alt="t('smart.tiemporeal.moderado')" />
                {{ t("smart.tiemporeal.moderado") }} &nbsp;&nbsp;
                <img src="../img/iconos/calidad3-3.png" :alt="t('smart.tiemporeal.malo')" />
                {{ t("smart.tiemporeal.malo") }}
              </dd>
            </dl>
          </div>
        </div>

        <ul class="row list_style_none m-0 p-0">
          <sensor-particulas v-if="dataFetched" :sensor="sensors.ENT_AQO_012"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.ENT_AQO_007"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.ENT_AQO_009"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.ENT_AQO_010"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.ENT_AQO_011"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_01"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_02"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_03"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_04"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_05"></sensor-particulas>
          <sensor-particulas v-if="dataFetched" :sensor="sensors.Alcoy_AQPMNGPRS_06"></sensor-particulas>
        </ul>

        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <dl class="row">
              <dt class="col-12 col-sm-2 text-left text-sm-right">{{ t("smart.tiemporeal.particulas") }} &#60; 1 µm</dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.pm1_des") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.particulas") }} &#60; 2,5 µm
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.pm25_des") }}
              </dd>
              <dt class="col-12 col-sm-2 text-left text-sm-right">
                {{ t("smart.tiemporeal.particulas") }} &#60; 10 µm
              </dt>
              <dd class="col-12 col-sm-10">
                {{ t("smart.tiemporeal.pm10_des") }}
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </section>

    <section class="section alter3-features" id="sonido">
      <div class="container">
        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <div class="section-heading text-center">
              <i class="fas fa-microphone fa-2x accent mb-3"></i>
              <h2 class="heading-line">
                {{ t("smart.tiemporeal.nivelsonido") }}
              </h2>
            </div>
          </div>
        </div>
        <ul class="row list_style_none m-0 p-0">
          <sensor-sonido
            v-if="dataFetched"
            :sensor="sensors.ENT_NLO_001"
            :mantenimiento="['laeq', 'lamax', 'la1', 'la10', 'la50', 'la90', 'la99']"
          ></sensor-sonido>
          <sensor-sonido v-if="dataFetched" :sensor="sensors.ENT_NLO_002"></sensor-sonido>
        </ul>
      </div>
    </section>

    <section class="section alter3-features" id="meteo">
      <div class="container">
        <div class="row gap-y">
          <div class="col-md-12" style="margin-top: 35px">
            <div class="section-heading text-center">
              <i class="fas fa-wind fa-2x accent mb-3"></i>
              <h2 class="heading-line">{{ t("smart.tiemporeal.meteo") }}</h2>
            </div>
          </div>
        </div>
        <ul class="row list_style_none m-0 p-0">
          <sensor-meteo v-if="dataFetched" :sensor="sensors.CF1_Sonda1_THR"></sensor-meteo>
          <sensor-meteo v-if="dataFetched" :sensor="sensors.EstMet01"></sensor-meteo>
        </ul>
      </div>
    </section>
  </div>
</template>
